import React from "react";
import Skeleton from "./Skeleton";
import skeletonStyles from "../../style/skeleton.module.css";
import "../../style/project/projectLayout.module.css";
import "../../style/project/projectTables.module.css";

const ProjectPageSkeleton = () => (
  <div
    className="project-page container page-shell pt-3 pt-md-5 pb-4 skeleton-page"
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading project"
  >
    <aside className={skeletonStyles.skeletonProjectToc} aria-hidden="true">
      <Skeleton className={skeletonStyles.skeletonTitle} />
      <Skeleton className={skeletonStyles.skeletonTocItem} />
      <Skeleton
        className={`${skeletonStyles.skeletonTocItem} ${skeletonStyles.skeletonTocItemShort}`}
      />
      <Skeleton className={skeletonStyles.skeletonTocItem} />
      <Skeleton
        className={`${skeletonStyles.skeletonTocItem} ${skeletonStyles.skeletonTocItemShort}`}
      />
      <Skeleton className={skeletonStyles.skeletonTocItem} />
    </aside>

    <div className="project-content skeleton-project-content">
      <Skeleton className={skeletonStyles.skeletonTitle} />
      <Skeleton className={skeletonStyles.skeletonHeroImage} />
      <div
        className={`${skeletonStyles.skeletonStack} ${skeletonStyles.skeletonStackLg} mt-4`}
      >
        <Skeleton className={skeletonStyles.skeletonSubtitle} />
        <Skeleton className={skeletonStyles.skeletonParagraph} />
        <Skeleton className={skeletonStyles.skeletonParagraph} />
        <Skeleton
          className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort}`}
        />
        <Skeleton className={skeletonStyles.skeletonParagraph} />
        <Skeleton
          className={`${skeletonStyles.skeletonParagraph} ${skeletonStyles.skeletonParagraphShort}`}
        />
      </div>
    </div>
  </div>
);

export default ProjectPageSkeleton;
